// A failed request can have an unknown delivery outcome. Leave that record and
// its successors queued with their original message IDs for the next attempt.
export async function publishRecordsInOrder<T>(records: T[], publish: (record: T) => Promise<unknown>) {
  let sentRecordCount = 0
  for (const record of records) {
    try {
      await publish(record)
      sentRecordCount += 1
    } catch {
      break
    }
  }
  return sentRecordCount
}
